export const LOGIN = "/login";
export const GET_USER_DETAIL = "/getuser";
export const CHANGE_PASSWORD = "/user/changePassword";

export const GET_TENANTS = "/tenant/getTenants";
export const GET_TENANT_DETAILS = "/tenant/getTenantDetails";
export const ADD_TENANT = "/tenant/addTenant";
export const UPDATE_TENANT = "/tenant/updateTenant";
export const DELETE_TENANT = "/tenant/deleteTenant";

export const GET_CONTRACTORS = "/contractor/getContractors";
export const GET_CONTRACTOR_DETAILS = "/contractor/getContractorDetails";
export const ADD_CONTRACTOR = "/contractor/addContractor";
export const UPDATE_CONTRACTOR = "/contractor/updateContractor";
export const DELETE_CONTRACTOR = "/contractor/deleteContractor";
export const UPDATE_CONTRACTOR_PROFILE = "/contractor/updateContractorProfile";
export const UPLOAD_CONTRACTOR_IMAGE = "/contractor/uploadImage";

export const GET_EMPLOYEES = "/employee/getEmployees";
export const GET_EMPLOYEES_BY_CONTRACTOR = "/employee/getEmployeesByContractor?tenant_id=";
export const GET_EMPLOYEE_DETAILS = "/employee/getEmployeeDetails";
export const ADD_EMPLOYEE = "/employee/addEmployee";
export const UPDATE_EMPLOYEE = "/employee/updateEmployee";
export const DELETE_EMPLOYEE = "/employee/deleteEmployee";
export const UPDATE_EMPLOYEE_PROFILE = "/employee/updateEmployeeProfile";
export const UPLOAD_EMPLOYEE_IMAGE = "/employee/uploadImage";

export const GET_TASKS = "/task/getTasks";
export const GET_TASKS_BY_CONTRACTOR = "/task/getTasksByContractor?tenant_id=";
//export const GET_TASKS_BY_EMPLOYEE = "/task/getTasksByEmployee?employee=";
//export const GET_DAILY_TASKS_BY_EMPLOYEE = "/task/getDailyTasksbyEmployee?employee=";
export const GET_TASK_DETAILS = "/task/getTaskDetails";
export const ADD_TASK = "/task/addTask";
export const UPDATE_TASK = "/task/updateTask";
export const DELETE_TASK = "/task/deleteTask";
export const GET_TASKLOG_BY_EMPLOYEE = "/task/getTaskLogbyEmployee?employee=";
export const ADD_TASKLOG = "/task/addTaskLog";
export const UPDATE_TASKLOG = "/task/updateTaskLog";
export const DELETE_TASKLOG = "/task/deleteTaskLog";
export const GET_DAILY_TASKLOG_BY_EMPLOYEE = "/task/getDailyTaskLogbyEmployee?employee=";
export const GET_TASK_LOGS_BY_CONTRACTOR = "/task/getTaskLogsByContractor?";
export const GET_TASK_LOGS_BY_TENANT= "/task/getTaskLogsByTenant?";
export const GET_EMPLOYEE_INVOICE ="/task/getEmployeeInvoiceLogs?";

export const GET_ROUTES = "/route/getRoutes";
export const GET_ROUTES_BY_CONTRACTOR = "/route/getRoutesbyContractor?tenant_id=";
export const GET_ROUTE_DETAILS = "/route/getRouteDetails";
export const ADD_ROUTE = "/route/addRoute";
export const UPDATE_ROUTE = "/route/updateRoute";
export const DELETE_ROUTE = "/route/deleteRoute";

export const GET_INVOICES = "/invoice/getInvoices?employee_id=";
export const GET_INVOICES_BY_TENANT = "/invoice/getInvoicesByTenant?tenant_id=";
export const GET_INVOICE_DETAILS = "/invoice/getInvoiceDetails";
export const ADD_INVOICE = "/invoice/addInvoice";
export const UPDATE_INVOICE = "/invoice/updateInvoice";
export const DELETE_INVOICE = "/invoice/deleteInvoice";

export const GET_PAY_SLIPS = "/slip/getPaySlips?employee_id=";
export const GET_PAY_SLIPS_BY_TENANT = "/slip/getAllPaySlips?tenant_id=";
export const GET_PAY_SLIP_DETAILS = "/slip/getPaySlipDetails";
export const ADD_PAY_SLIP = "/slip/addPaySlip";
export const UPDATE_PAY_SLIP = "/slip/updatePaySlip";
export const DELETE_PAY_SLIP = "/slip/deletePaySlip";

export const GET_RULES = "/rules/getRulesbyTenant?tenant_id=";
export const ADD_RULES = "/rules/addRules";
export const UPDATE_RULES = "/rules/updateRules";